export default __webpack_public_path__ + "static/media/Android Preview.ea4f40c8.png";